<template>
  <div class="features-field ">
    <div>
      <span class="title-area">
        <b>Additional Features to Consider:</b> There are other important
        features of your roof that determine its resilience to hurricane-force
        winds.
      </span>
      <!--   <span class="material-icons-outlined" @click="showList = !showList"
        >expand_more</span
      > -->
      <button style="width:100%; margin: 12px 0px 0px;"
        class="btn btn-rounded z-depth-0 grey darken-3 white-text waves-effect" @click="showList = !showList">
        {{ !showList ? 'View More' : 'Close' }} <i class="material-icons white-text right">{{ !showList ? 'expand_more' :
          'expand_less' }}</i>
      </button>
    </div>
    <ol v-if="showList">
      <li>
        A very important feature is the spacing of fasteners (e.g. galvanized
        head clout nails) in the<a href="#" @click.prevent="setHelper('D687')">
          roof sheathing/decking
        </a>
        - that is, the wood boards/panels that are fixed to the rafters. The
        OECS Building Guidelines note that "Sheathing loss is one of the most
        common structural failures in hurricanes. It is extremely important to
        have proper fastener spacing on all panels. Loss of just one panel in a
        windstorm can lead to total building failure. Closer spacing may be
        required at corners, edges and ridges." See
        <a href="#" @click.prevent="setHelper('F837')">illustration of roof areas of highest pressure for wind loads
        </a>
        and
        <a href="#" @click.prevent="setHelper('F290')">common sheathing attachment mistakes </a>. In the case of plywood
        decking, it should be fastened to the rafters
        or purlins at a spacing of not less than 24 inches. Where timber boards
        are used as decking, the timber should be secured at each purlin by at
        least two galvanized head clout nails at least 1.6 inches long. You cannot observe the spacing and type of
        these fasteners once a house is
        constructed. None-the-less, you may have
        knowledge of this or you can ask your
        contractor or someone else familiar with
        your home's construction.
        <br />
        <br />
        Include this knowledge in your assessment
        by a note in your justification for selecting a
        particular expected impact level. This feature should be treated like other &quot;core&quot;
        roof resiliency features - if absent, it may
        lead to &quot;Major&quot; impact.
      </li>
      <br />
      <li>
        Another important feature is the use of patented hurricane straps
        (rafter ties) for fixing rafters to plates,
        <a href="#" @click.prevent="setHelper('D734')">purlins </a> and
        <a href="#" @click.prevent="setHelper('D440')">ridge boards</a>.
        Depending on the construction style of your roof, you may or may not be
        able to see these. An example of these is provided in the illustration
        of a
        <a href="#" @click.prevent="setHelper('F339')">
          Strongly Constructed Gable Roof</a>. If you have knowledge of the presence or absence of these patented
        hurricane straps in your roof, include this knowledge in your assessment
        by a note in your justification for selecting a particular expected
        impact level. This feature should be treated like other "core" roof
        resiliency features - if absent, it may lead to "Major" impact.
      </li>
    </ol>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "FeaturesField",
  props: {},
  data() {
    return { showList: false };
  },
  mounted() { },
  computed: {},
  methods: {
    ...mapActions("Helpers", ["setHelper"]),
  },
};
</script>
<style lang="scss" scoped>
.features-field {
  margin: 24px -24px 24px;
  width: calc(100% + 48px);
  padding: 24px 38px;
  color: black;
  position: relative;
  font-size: 15px;
  background: #fbd15e;

  @media screen and (min-width: 1024px) {
    margin: 24px 0px 24px;
    width: 100%;
    border-radius: 8px;
  }

  .title-area {
    font-size: 16px;
  }

  /*    &::before {
    content: ' ';
    height: 25px;
    width: 2px;
    position: absolute;
    bottom: -25px;
    left: 27px;
    z-index: 0;
    border-left: 2px solid #5374f8;
   } */
  a {
    //  color: #000b4a;
    font-weight: 600;
  }

  ol {
    padding: 0px 0px 0px 24px;
    transition: height 200ms;
  }
}
</style>
